import { Root } from '@radix-ui/react-tabs'
import * as React from 'react'

import { styled } from '~/styled'

import { TabsContent } from './TabsContent'
import { TabsTrigger } from './TabsTrigger'
import { TabsTriggerList } from './TabsTriggerList'

const StyledRoot = styled(Root, {
  base: ['w-full']
})

export const Tabs = Object.assign(StyledRoot, {
  TriggerList: TabsTriggerList,
  Trigger: TabsTrigger,
  Content: TabsContent
})

StyledRoot.displayName = 'Tabs'
